import { ModelSetTransformer, ModelTransformer } from '../common/common.model';
import { Util } from '../common/common.util';

export interface ExtCaoMetricCyclePerformanceItem {
    startDate: string;
    endDate: string;
    overAllActual: number;
    overallTarget: number;
    queueLevelActual: number;
    queueLevelTarget: number;
    endOverallActual: number;
    endOverallTarget: number;
    endQueueActual: number;
    endQueueTarget: number;
    journalID: number;
    journalTypeID: number;
    goalValue: number;
}

export interface CaoMetricCyclePerformanceLevel {
    overallActual: number;
    overallTarget: number;
    queueActual: number;
    queueTarget: number;
}

export interface CaoMetricCyclePerformanceItem {
    startDate: Date;
    endDate: Date;
    start: CaoMetricCyclePerformanceLevel;
    end: CaoMetricCyclePerformanceLevel;
    goalValue: number;
}

export interface CaoMetricCyclePerformance {
    items: CaoMetricCyclePerformanceItem[];
}

class CaoMetricCyclePerformanceItemModelTransformer
    implements
        ModelTransformer<
            CaoMetricCyclePerformanceItem,
            ExtCaoMetricCyclePerformanceItem
        >
{
    transform(
        model: ExtCaoMetricCyclePerformanceItem,
    ): CaoMetricCyclePerformanceItem {
        return {
            startDate: Util.dateToDate(model.startDate),
            endDate: Util.dateToDate(model.startDate),
            start: {
                overallActual: model.overAllActual,
                overallTarget: model.overallTarget,
                queueActual: model.queueLevelActual,
                queueTarget: model.queueLevelTarget,
            },
            end: {
                overallActual: model.endOverallActual,
                overallTarget: model.endOverallTarget,
                queueActual: model.endQueueActual,
                queueTarget: model.endQueueTarget,
            },
            goalValue: model.goalValue,
        };
    }
}

class CaoMetricCyclePerformanceItemModelSetTransformer extends ModelSetTransformer<
    CaoMetricCyclePerformanceItem,
    ExtCaoMetricCyclePerformanceItem
> {
    protected newTransformer(): ModelTransformer<
        CaoMetricCyclePerformanceItem,
        ExtCaoMetricCyclePerformanceItem
    > {
        return new CaoMetricCyclePerformanceItemModelTransformer();
    }
}

export class CaoMetricCyclePerformanceModelTransformer
    implements
        ModelTransformer<
            CaoMetricCyclePerformance,
            ExtCaoMetricCyclePerformanceItem[]
        >
{
    transform(
        model: ExtCaoMetricCyclePerformanceItem[],
    ): CaoMetricCyclePerformance {
        const items =
            new CaoMetricCyclePerformanceItemModelSetTransformer().transform(
                model,
            );
        return {
            items,
        };
    }
}

export function validateCaoMetricCyclePerformance(
    model: CaoMetricCyclePerformance,
): void {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    const valid =
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        model != null && model.items != null && model.items.length !== 0;
    if (!valid) {
        throw new Error('CaoMetricCyclePerformance not valid');
    }
}
